import { Component, Inject  } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HomeDelivery } from "../../models/home-delivery";

@Component({
  selector: 'app-batch-scanning-dialog',
  templateUrl: './batch-scanning-dialog.component.html',
  styleUrls: ['./batch-scanning-dialog.component.scss']
})
export class BatchScanningDialogComponent {

  actualNumberOfItems: number | null;
  formGroup: FormGroup;
  expectedNumberOfItems: number;

  constructor(private dialogRef: MatDialogRef<BatchScanningDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    const homeDelivery = data.homeDelivery as HomeDelivery;
    this.expectedNumberOfItems = homeDelivery.status.total;
    this.actualNumberOfItems = null;
    this.formGroup = new FormGroup({
      actualNumberOfItems: new FormControl('', [Validators.required, Validators.min(1), Validators.max(10000)])
    });
  }

  onSubmit(e: Event) {
    e.preventDefault();
    if (this.formGroup.valid) {
      this.onConfirm();
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close(this.formGroup.value.actualNumberOfItems);
  }
}
